import { observer } from 'mobx-react';
import * as React from 'react';

interface IScrollIntoView {
    children: JSX.Element;
    offset?: number;
    enabled?: boolean;
}

@observer
export class ScrollIntoView extends React.Component<IScrollIntoView> {
    private refElement: React.RefObject<HTMLDivElement> = React.createRef();

    public scrollIntoViewCallback = (offset?: number) => {
        if (!this.refElement?.current) {
            return null;
        }

        const _offset = offset || this.props.offset || 0;

        if (this.refElement && this.refElement.current) {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const { top } = this.refElement.current.getBoundingClientRect() || {};

            window.scrollTo({
                top: scrollTop + top + _offset,
                behavior: 'smooth'
            });
        }
    };

    render() {
        if (!this.props.enabled) {
            return this.props.children;
        }

        const childrenWithProps = React.cloneElement(this.props.children, {
            scrollIntoView: this.scrollIntoViewCallback
        });

        return <div ref={this.refElement}>{childrenWithProps}</div>;
    }
}
